module.exports = __webpack_public_path__ + "static/media/Artboard3.5f25d72a.png";